import { render, staticRenderFns } from "./SectionMenu.vue?vue&type=template&id=f4d8315c&scoped=true&"
import script from "./SectionMenu.vue?vue&type=script&lang=ts&"
export * from "./SectionMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SectionMenu.vue?vue&type=style&index=0&id=f4d8315c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d8315c",
  null
  
)

export default component.exports